import { checkMaxActivities } from './utils/activityUtils.js';

(function () {
  // Function to update activities order
  const updateActivitiesOrder = () => {
    const activities = document.querySelectorAll('.evaluation-form-item');
    const orderInput = document.getElementById('activities-order');
    if (orderInput) {
      const order = Array.from(activities)
        .map(activity => {
          const counterInput = activity.querySelector(
            'input[name*="-counter"]'
          );
          return counterInput ? counterInput.value : '';
        })
        .filter(Boolean)
        .join(',');
      orderInput.value = order;
    }
  };

  // Function to track deleted activities
  const trackDeletedActivity = activityId => {
    // Only track if activityId exists and is not empty
    if (activityId && activityId !== '') {
      let deletedActivitiesInput =
        document.getElementById('deleted-activities');

      // Create the input if it doesn't exist
      if (!deletedActivitiesInput) {
        deletedActivitiesInput = document.createElement('input');
        deletedActivitiesInput.type = 'hidden';
        deletedActivitiesInput.id = 'deleted-activities';
        deletedActivitiesInput.name = 'deleted_activities';
        document
          .getElementById('create-cap-form')
          .appendChild(deletedActivitiesInput);
      }

      // Add the deleted activity ID to the list
      const currentDeleted = deletedActivitiesInput.value
        ? deletedActivitiesInput.value.split(',')
        : [];
      if (!currentDeleted.includes(activityId)) {
        currentDeleted.push(activityId);
        deletedActivitiesInput.value = currentDeleted.join(',');
      }
    }
  };

  // Use event delegation for dynamically added delete buttons
  document.addEventListener('click', function (event) {
    const deleteButton = event.target.closest('.js-delete-activity');
    if (deleteButton) {
      const modalId = deleteButton.dataset.target;
      const modal = document.getElementById(modalId);
      const modalOverlay = document.getElementById('modalOverlay');
      const formItem = deleteButton.closest('.evaluation-form-item');

      if (modal && formItem) {
        // Show modal and overlay
        modal.removeAttribute('aria-hidden');
        modal.classList.add('open');
        modalOverlay.style.display = 'block';

        // Handle confirm button
        const confirmButton = modal.querySelector('.js-clear-confirmation');
        if (confirmButton) {
          confirmButton.addEventListener(
            'click',
            function () {
              // Get the activity ID before removing the form item
              const activityIdInput =
                formItem.querySelector('input[name*="-id"]');
              const activityId = activityIdInput ? activityIdInput.value : null;

              // Only track if it's a saved activity (has an ID)
              if (activityId && activityId !== '') {
                trackDeletedActivity(activityId);
              }

              // Remove the form item
              formItem.remove();

              // Update total forms count
              const totalForms = document.querySelector(
                'input[type="hidden"][name="TOTAL_FORMS"]'
              );
              if (totalForms) {
                totalForms.value = parseInt(totalForms.value) - 1;
              }

              // Hide modal and overlay
              modal.setAttribute('aria-hidden', 'true');
              modal.classList.remove('open');
              modalOverlay.style.display = 'none';

              // Check max activities after deletion
              checkMaxActivities();

              // Update activities order after deletion
              updateActivitiesOrder();
            },
            { once: true }
          );
        }
      }
    }
  });
})();
